module.exports = __webpack_public_path__ + "img/high_five.fb4be7ae.png";